import { useState } from "react";

import {
  Drawer,
  Button,
  Text,
  Header,
  Form,
  useDrawer,
} from "../../design";
import { translate } from "../../utils/translations";
import SubscriptionGroupCard from "../cards/subscription-group";
import MergeSubscriptionSelectDrawer from "./merge-subscription-select";

function MergeSubscriptionsDrawer(props: any) {
  const drawers = useDrawer();

  const [selectedGroupIndex, setselectedGroupIndex] = useState(0);

  const toggleSubscriptionSelectDrawer = () => {
    drawers.open({
      component: MergeSubscriptionSelectDrawer,
      props: {
        selectedGroup: props.availableGroups[selectedGroupIndex],
        reloadContracts: props.reloadContracts,
      }
    })
  }

  return (
    <Drawer id="merge-subscriptions" title={translate('merge_subscriptions_drawer_title')} active={props.active} toggleActive={props.toggleActive}>
      <Drawer.Body>
        <Text.P1 className="mb-3">{translate('merge_subscription_body')}</Text.P1>
        <Header.H3>{translate('merge_subscription_shipping_address_title')}</Header.H3>
        <div className="mt-3">
          {props.availableGroups.map((group: any, i: number) => {
            return (
              <Form.Choice
                className="mb-3"
                key={i}
                value={i}
                selectedValue={selectedGroupIndex}
                label={
                  <div className="ms-1">
                    <SubscriptionGroupCard group={group} />
                  </div>
                }
                onChange={() => {
                  setselectedGroupIndex(i);
                }}
              />
            )
          })}
        </div>
      </Drawer.Body>
      <Drawer.Footer>
        <div className="d-flex flex-column">
          <Button size="lg" className="m-2" onClick={toggleSubscriptionSelectDrawer}>{translate('merge_subscription_next_button')}</Button>
          <Button size="lg" variant="underline" className="m-2" onClick={props.toggleActive}>{translate('go_back_button')}</Button>
        </div>
      </Drawer.Footer>
    </Drawer>
  );
}

export default MergeSubscriptionsDrawer;
